import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ff6e613a&scoped=true&functional=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=ff6e613a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "ff6e613a",
  null
  
)

export default component.exports